import Url from '../utils/url';

// 美团拼场微信小程序
export default {
  appName: 'wxapp_meituan_pinchang',
  useKNB: false,
  sellChannel: 39,
  theme: 'maoyan',
  hostPrefix: '//show.maoyan.com/qqw',
  hostBetaPrefix: '//show.test.maoyan.com/qqw',
  ajaxUrl: '//show.maoyan.com/maoyansh/myshow/ajax',
  ajaxBetaUrl: '//show.test.maoyan.com/maoyansh/myshow/ajax',
  linkMap: {
    // 地址跳转映射
    // 首页
    '/myshow/': '/',
    '/myshow/index.html': '/',
    '/movieshow/index.html': '/',
    // 列表相关
    '/movieshowlist/graphic-detail.html': '/graphic',
    '/movieshowlist/show-ticket.html': '/list',
    '/movieshowlist/show-merchant.html': '/merchants',
    '/movieshowlist/show-detail.html': '/detail',
    '/movieshowlist/group.html': '/group',
    '/movieshowlist/search.html': '/search',
    '/movieshowlist/show-shop.html': '/shop',
    // 下单相关
    '/movieshoworder/goods.html': '/tickets',
    '/movieshoworder/pre-order.html': '/confirm',
    '/movieshoworder/area.html': '/partition',
    '/movieshoworder/add-address.html': '/add-addr',
    '/movieshoworder/choose-address.html': '/choose-addr',
    '/movieshoworder/coupon-detail.html': '/coupon-detail',
    '/movieshoworder/seats.html': '/seats',
    '/movieshoworder/coupon.html': '/coupon',
    '/movieshoworder/order-detail.html': '/order-detail',
    '/movieshoworder/order-list.html': '/order-list',
    '/movieshoworder/real-names.html': '/realname',
    '/movieshoworder/seat-area.html': '/seat-area',
    '/movieshoworder/select-seats.html': '/select-seats',
    '/movieshoworder/search-order.html': '/search-order'
  },
  getUserInfo: function getUserInfo() {
    // 美团拼场微信小程序打开webview 页面，url 都带有这个参数
    var token = '';
    token = Url.getQuery('_token') || Url.getHashQuery('_token');
    if (token) {
      localStorage.setItem('_token', token);
    } else {
      token = localStorage.getItem('_token');
    }
    return {
      token: token
    };
  },
  getCity: function getCity() {
    var cityId = '';
    cityId = Url.getQuery('_cityId') || Url.getHashQuery('_cityId');
    if (cityId) {
      localStorage.setItem('cityId', cityId);
    } else {
      cityId = localStorage.getItem('cityId');
    }
    return {
      type: 'mt',
      cityId: cityId
    };
  },
  login: function login() {}
};